import React from 'react';
import { Monitor, X } from 'lucide-react';
import { useIsMobile } from '../hooks/use-mobile';

const STORAGE_KEY = 'mentis_mobile_banner_dismissed';

const MobileDesktopBanner: React.FC = () => {
  const isMobile = useIsMobile();
  const [dismissed, setDismissed] = React.useState<boolean>(() => {
    if (typeof window === 'undefined') return false;
    return window.sessionStorage.getItem(STORAGE_KEY) === '1';
  });

  if (!isMobile || dismissed) return null;

  const handleDismiss = () => {
    setDismissed(true);
    try {
      window.sessionStorage.setItem(STORAGE_KEY, '1');
    } catch {
      // sessionStorage may be unavailable (private mode); ignore.
    }
  };

  return (
    <div className="md:hidden sticky top-0 z-50 flex items-center gap-2 border-b border-cyan-500/30 bg-gradient-to-r from-cyan-600/95 to-blue-600/95 px-3 py-2 text-white shadow-md backdrop-blur">
      <Monitor className="h-4 w-4 flex-shrink-0" aria-hidden="true" />
      <p className="flex-1 text-xs leading-snug">
        For the best experience, open Mentis AI on a desktop browser.
      </p>
      <button
        type="button"
        onClick={handleDismiss}
        aria-label="Dismiss"
        className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-md text-white/90 hover:bg-white/15 hover:text-white"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};

export default MobileDesktopBanner;
